if (!customElements.get("product-price")) {
  customElements.define(
    "product-price",
    class ProductPrice extends window.Component {
      constructor() {
        super();
        this.addSubscribeContext();
        this.salePriceElement = this.querySelector(".price-item--sale");
        this.comparePriceElement = this.querySelector(".price-item--regular");
        this.discountElement = this.querySelector(".discount");
      }

      getPriceFormat = () => {
        return this.getState("moneyFormat");
      };

      getPriceText = (price) => {
        const format = this.getPriceFormat();
        const priceFormat = window.Shopify.formatMoney(
          `${price || 0}`,
          format ?? "${{amount}}"
        );
        return `${priceFormat}`;
      };

      addSubscribeContext() {
        this.subscribeContext((state, previousState) => {
          if (state.variantSelected?.id === previousState.variantSelected?.id) {
            return;
          }
          const price = state.variantSelected?.price || 0;
          const comparePrice = state.variantSelected?.compare_at_price || 0;
          const saving = comparePrice - price;
          const percent = Math.round((saving / comparePrice) * 100);
          const priceText = this.getPriceText(price);
          const comparePriceText = this.getPriceText(comparePrice);
          if (this.salePriceElement) {
            this.salePriceElement.innerHTML = priceText;
          }
          if (price < comparePrice) {
            if (this.discountElement) {
              this.discountElement.style.display = "inline";
              this.discountElement.innerHTML = `${percent}% OFF`;
            }
            if (this.comparePriceElement) {
              this.comparePriceElement.style.display = "inline";
              this.comparePriceElement.innerHTML = comparePriceText;
            }
          } else {
            if (this.discountElement) {
              this.discountElement.style.display = "none";
            }
            if (this.comparePriceElement) {
              this.comparePriceElement.style.display = "none";
            }
          }
        });
      }
    }
  );
}
